import React from "react";
import { makeLocalStorageAdapter } from "../cache";
import PrivateRoute from "../../../presentation/routes/private-route";
import { makeLoadAccountByToken } from "../usecases/load-account-by-token-factory";

export const makePrivateRoute = (
  whiteList: string[],
  children: React.ReactNode,
  redirectUnauthorized?: string
) => {
  return (
    <PrivateRoute
      loadAccountByToken={makeLoadAccountByToken()}
      localStorageAdapter={makeLocalStorageAdapter()}
      whiteList={whiteList}
      redirectUnauthorized={redirectUnauthorized}
    >
      {children}
    </PrivateRoute>
  );
};
